import { render } from "./orderItemsComponent.vue?vue&type=template&id=5f217316"
import script from "./orderItemsComponent.vue?vue&type=script&lang=js"
export * from "./orderItemsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__